export const encounterjobinfoSelector = state => state.encounterjobinfo;